<template>
  <!-- COL AREA -->
  <div class="vx-row">
    <!-- COL 1 -->
    <div class="vx-col w-full lg:w-1/4">
      <vx-card title="About" class="mt-base">
        <!-- ACTION SLOT -->
        <template slot="actions">
          <feather-icon icon="MoreHorizontalIcon"></feather-icon>
        </template>

        <!-- USER BIO -->
        <div class="user-bio">
          <p>Tart I love sugar plum I love oat cake. Sweet roll caramels I love jujubes. Topping cake wafer.</p>
        </div>

        <!-- OTEHR DATA -->
        <div class="mt-5">
          <h6>Joined:</h6>
          <p>November 15, 2015</p>
        </div>

        <div class="mt-5">
          <h6>Lives:</h6>
          <p>New York, USA</p>
        </div>

        <div class="mt-5">
          <h6>Email:</h6>
          <p>bucketful@fiendhead.org</p>
        </div>

        <div class="mt-5">
          <h6>Website:</h6>
          <p>www.pixinvent.com</p>
        </div>

        <div class="social-links flex mt-4">
          <feather-icon svgClasses="h-7 w-7 cursor-pointer bg-primary p-1 text-white rounded" class="mr-2" icon="FacebookIcon"></feather-icon>
          <feather-icon svgClasses="h-7 w-7 cursor-pointer bg-primary p-1 text-white rounded" class="mr-2" icon="TwitterIcon"></feather-icon>
          <feather-icon svgClasses="h-7 w-7 cursor-pointer bg-primary p-1 text-white rounded" class="mr-2" icon="InstagramIcon"></feather-icon>
        </div>
      </vx-card>
      <!-- PAGES SUGGESTION -->
      <vx-card title="Suggested Pages" class="mt-base">
        <ul class="page-suggestions-list">
          <li class="page-suggestion flex items-center mb-4" v-for="page in suggestedPages" :key="page.index">
            <div class="mr-3">
<!--              <vs-avatar class="m-0" :src="page.img" size="35px" />-->
            </div>
            <div class="leading-tight">
              <p class="font-medium">{{ page.title  }}</p>
              <span class="text-xs">{{ page.type  }}</span>
            </div>
            <div class="ml-auto">
              <div class="flex">
                <feather-icon icon="StarIcon" svgClasses="h-4 w-4" class="mr-2 cursor-pointer"></feather-icon>
              </div>
              <!-- <span class="flex bg-primary rounded p-2 text-white"><feather-icon icon="UserPlusIcon" svgClasses="w-4 h-4"></feather-icon></span> -->
            </div>
          </li>
        </ul>
      </vx-card>
    </div>
  </div>
</template>

<script>
    export default {
        name: "StaffRecord",
      data() {
          return {
            suggestedPages: [
              {  title: 'Rockose',      type: 'Company'          },
              { title: 'The Devil\'s', type: 'Clothing Store'   },
              {  title: 'The Magician', type: 'Public Figure'    },
              {  title: 'AC/DC',        type: 'Music'            },
              {  title: 'eat hard',     type: 'restaurant / bar' },
              {  title: 'B4B',          type: 'Beauty Store'     },
              {  title: 'Kylie Jenner', type: 'Public Figure'    },
              {  title: 'RDJ',          type: 'Actor'            },
              {  title: 'Taylor Swift', type: 'Music'            }
            ],
          }
      }
    }
</script>

<style scoped>

</style>
